$_GET = {};
if ( document.location.toString().indexOf( '?' ) !== -1 ) {
	var query = document.location
		.toString()
	// get the query string
		.replace( /^.*?\?/, '' )
	// and remove any existing hash string (thanks, @vrijdenker)
		.replace( /#.*$/, '' )
		.split( '&' );

	for ( var i = 0, l = query.length; i < l; i++ ) {
		var aux = decodeURIComponent( query[ i ] ).split( '=' );
		$_GET[ aux[ 0 ] ] = aux[ 1 ];
	}
}

var debug2 = function( $text ) {
	if ( window.console ) {
		console.log( $text + ' ' + Error().lineNumber );
	}
};

jQuery( function( $ ) {
//var debug = console.log.bind(window.console)

	isDebug = true; // toggle this to turn on / off for global controll

	if ( isDebug ) {
		log = console.log.bind( window.console );
	} else {
		log = function() {};
	}
} );

jQuery( document ).ready( function( $ ) {
//   alert('ok');

	console.log( 'screen hight is: ' + screen.height );
	console.log( 'screen width is: ' + screen.width );

	window.setupLightwindows();

	//var links = $$('.lightwindow_iframe_link');
	//	links.each(function(link) {
	//		Event.observe(link, 'click', function() {parent.myLightWindow.activate(null, link);}, false);
	//		link.onclick = function() {return false;};
	//});

	//TweenMax.to($(".st"), 2, {rotation:360,ease:Linear.easeNone,repeat:-1});

	//var window.ps = {}; // global Object container

	/*var window.MyLib = {}; // global Object container
MyLib.value = 1;
MyLib.increment = function() { MyLib.value++; }
MyLib.show = function() { alert(MyLib.value); }

MyLib.value=6;
MyLib.increment();
MyLib.show(); // alerts 7
*/

	var tl = new TimelineMax( { paused: true } );
	var $panel1 = $( 'div.panel1' ); //70%
	var $panel2 = $( 'div.panel2' ); //5%
	var $panel3 = $( 'div.panel3' ); //25%

	var $focusWidth = 70;
	var $barWidth = 6;
	var $barfocusWidth = 30;
	var $drawerWidth = 30;
	var $focusOverlap = 5;

	var $speed = 0.2;
	var $loadspeed = 0.8;

	window.allowhover = true;
	window.drawer_moving = false;
	window.drawer_1_open = false;
	window.drawer_2_open = false;

	window.panel1_ID = getCookie( 'ps_panel1' );
	window.panel3_ID = getCookie( 'ps_panel3' );
	window.link_ID = '';
	window.hasLink = false;
	window.focusLinkStatus = false;

	window.panelLoading = {
		panel1: false,
		panel3: false,
	};

	window.panel3Loading = false;

	/*// Create the measurement node
var scrollDiv = document.createElement("div");
scrollDiv.className = "scrollbar-measure";
document.body.appendChild(scrollDiv);
log("start scroll");

// Get the scrollbar width
var $scrollbarWidthPX = scrollDiv.offsetWidth - scrollDiv.clientWidth;
var $scrollbarWidth = ($scrollbarWidthPX / $( window ).width());

// Delete the DIV
document.body.removeChild(scrollDiv);
log("end scroll");
*/

	var $scrollbarWidthPX = 0;
	//var $scrollbarWidth = ($scrollbarWidthPX / $( window ).width());
	var $scrollbarWidth = 0;

	// http://manos.malihu.gr/jquery-custom-content-scroller/
	$( '.panel' ).mCustomScrollbar( {
		axis: 'y', // vertical scrollbar
		theme: 'inset-dark',
		autoExpandScrollbar: 1,
		scrollInertia: 0,
		setLeft: 0,
		setTop: 0,
		documentTouchScroll: true,
		advanced: {
			autoExpandHorizontalScroll: true,
		},

	} );

	/*$(".scroll .content").mCustomScrollbar({
    axis:"x", // vertical and horizontal scrollbar
	theme:"3d-thick-dark",
	autoExpandScrollbar: true,
	scrollInertia:0,
	setLeft: 0,
	setTop: 0,
	advanced:{
		autoExpandHorizontalScroll: true,
	}
});*/

	//$('.scrollbar-inner').scrollbar({});

	/*$('.focus').html('	\
	<div class="circle">\
		<div class="circle__inner">\
			<div class="circle__wrapper">\
				<div class="circle__content">\
					Click to Focus\
				</div>\
			</div>\
		</div>\
	</div>\
');*/

	resizeContent = function() {
		setTimeout( function() {
			//jQuery('.panel1 div:first-child,.panel2 div:first-child,.panel3 div:first-child').scrollbar('destroy');
			//$('.scrollbar-dynamic').scrollbar('destroy');
			$( '.panel .content * iframe' ).each( function( index ) {
				panelWidth = ( $( this ).closest( '.panel' ).width() - $scrollbarWidthPX - 40 );

				currentWidth = $( this ).width();
				currentHeight = $( this ).height();

				log( ' ' + currentWidth + ' ' + currentHeight );

				ratio = panelWidth / currentWidth;
				newWidth = currentWidth * ratio;
				newHeight = currentHeight * ratio;

				//$(this).width(newWidth);
				//$(this).height(newHeight);

				TweenMax.to( $( this ), $speed, {
					width: newWidth,
					height: newHeight,
				} );

				//$(".panel").mCustomScrollbar("update");
				log( ratio + ' ' + newWidth + ' ' + newHeight );
			} );

			//jQuery('.panel1 div:first-child,.panel2 div:first-child,.panel3 div:first-child').scrollbar();
			//$('.scrollbar-dynamic').scrollbar({});
		}, ( 1000 * $speed ) );
	};

	lockDrawers = function() {
		window.drawer_moving = true;
		log( 'locked' );
	};

	unlockDrawers = function() {
		window.drawer_moving = false;
		log( 'unlocked' );
	};

	closeDrawer = function( drawerNumber ) {
		if ( window.drawer_moving == true ) {
			log( window.drawer_moving );
			return;
		}
		if ( ! drawerNumber ) {
			return;
		} else if ( drawerNumber == 1 ) {
		//lockDrawers();
			log( 'closing drawer ' + drawerNumber );
			TweenMax.to( $( '.drawer1' ), $speed, { left: '-30%', onComplete: unlockDrawers } );
			$( '.drawer1-toggle .handle img' ).attr( 'src', '/wp-content/themes/soledad-child/img/ui/arrow1rw.svg' );
			$( '.drawer1,.panel1' ).removeClass( 'open' );
		} else if ( drawerNumber == 2 ) {
		//lockDrawers();
			log( 'closing drawer ' + drawerNumber );
			TweenMax.to( $( '.drawer2' ), $speed, { right: '-30%', onComplete: unlockDrawers } );
			$( '.drawer2-toggle .handle img' ).attr( 'src', '/wp-content/themes/soledad-child/img/ui/arrow1lw.svg' );
			$( '.drawer2,.panel3' ).removeClass( 'open' );
		}
		setCookie( 'ps_drawer' + drawerNumber + '', 'closed' );
	};

	openDrawer = function( drawerNumber ) {
		if ( window.drawer_moving == true ) {
			log( window.drawer_moving );
			return;
		}
		if ( ! drawerNumber ) {
			return;
		} else if ( drawerNumber == 1 ) {
		//lockDrawers();
			log( 'opening drawer ' + drawerNumber );
			TweenMax.to( $( '.drawer1' ), $speed, { left: 0, onComplete: unlockDrawers } );
			$( '.drawer1,.panel1' ).addClass( 'open' );
			$( '.drawer1-toggle .handle img' ).attr( 'src', '/wp-content/themes/soledad-child/img/ui/arrow1lw.svg' );
		} else if ( drawerNumber == 2 ) {
		//lockDrawers();
			log( 'opening drawer ' + drawerNumber );
			TweenMax.to( $( '.drawer2' ), $speed, { right: 0, onComplete: unlockDrawers } );
			$( '.drawer2-toggle .handle img' ).attr( 'src', '/wp-content/themes/soledad-child/img/ui/arrow1rw.svg' );
			$( '.drawer2,.panel3' ).addClass( 'open' );
		}
		// $(".drawer").mCustomScrollbar("update");
		setCookie( 'ps_drawer' + drawerNumber + '', 'open' );
	};

	toggleDrawer = function( drawerNumber ) {
		if ( ! drawerNumber ) {

		} else {
		//log("toggling drawr "+drawerNumber+" "+$('.drawer'+drawerNumber).html());
			if ( ! $( '.drawer' + drawerNumber ).hasClass( 'open' ) ) {
				openDrawer( drawerNumber );
			} else {
				closeDrawer( drawerNumber );
			}
		}
	};

	if ( ! getCookie( 'ps_drawer1' ) ) {

	} else if ( getCookie( 'ps_drawer1' ) == 'open' ) {
		log( '1 open' );
		openDrawer( 1 );
	}

	if ( ! getCookie( 'ps_drawer2' ) ) {

	} else if ( getCookie( 'ps_drawer2' ) == 'open' ) {
		log( '2 open' );
		openDrawer( 2 );
	}

	$( '.drawer1-toggle' ).click( function() {
		toggleDrawer( 1 );
	} );

	/*$('.drawer1-toggle').hover(function() {
	openDrawer(1);
});
*/
	$( '.close-drawer1,.panel1' ).click( function() {
		closeDrawer( 1 );
	} );

	$( '.drawer2-toggle' ).click( function() {
		toggleDrawer( 2 );
	} );

	/*$('.drawer2-toggle').hover(function() {
	openDrawer(2);
});*/

	$( '.close-drawer2,.panel3' ).click( function() {
		closeDrawer( 2 );
	} );

	unbindAll = function() {
		$( 'div.panel1 .focus' ).unbind( 'click' );
		$( 'div.panel2 .focus' ).unbind( 'click' );
		$( 'div.panel3 .focus' ).unbind( 'click' );
		$( '' ).unbind( 'click' );
		$( '' ).unbind( 'click' );
		$( '' ).unbind( 'click' );
		$( '' ).unbind( 'click' );
		//	$('').unbind('click');
	};

	unbindPanelFocus = function() {
		$( 'div.panel1 .focus' ).unbind( 'click' );
		$( 'div.panel2 .focus' ).unbind( 'click' );
		$( 'div.panel3 .focus' ).unbind( 'click' );
		//	$('').unbind('click');
	};

	focusFullPanel1 = function() {
		TweenMax.to( $panel1, $speed, {
			width: 94 + '%',
		} );
		TweenMax.to( $panel2, $speed, {
			width: 3 + '%',
		} );
		TweenMax.to( $panel3, $speed, {
			width: 3 + '%',
		} );
		//	unbindPanelFocus();
		$( '.panel1' ).addClass( 'active' );
		$( '.panel2, .panel3' ).removeClass( 'active' );
	};

	focusPanel1 = function() {
		TweenMax.to( $panel1, $speed, {
			width: $focusWidth + '%',
		} );
		TweenMax.to( $panel2, $speed, {
			width: 1 + '%',
		} );
		TweenMax.to( $panel3, $speed, {
			width: ( 50 - $focusWidth - 1 ) + '%',
		} );
		$( '.panel1' ).addClass( 'active' );
		$( '.panel2, .panel3' ).removeClass( 'active' );
	};

	focusPanel2 = function() {
		TweenMax.to( $panel1, $speed, {
			width: ( ( 50 - $barfocusWidth ) / 2 ) + '%',
		} );
		TweenMax.to( $panel2, $speed, {
			width: $barfocusWidth + '%',
		} );
		TweenMax.to( $panel3, $speed, {
			width: ( ( 50 - $barfocusWidth ) / 2 ) + '%',
		} );
		//$('.panel2').addClass('active');
		$( '.panel1, .panel2, .panel3' ).addClass( 'active' );
	};

	focusPanel3 = function() {
		TweenMax.to( $panel1, $speed, {
			width: ( 50 - $focusWidth - $barWidth ) + '%',
		} );
		TweenMax.to( $panel2, $speed, {
			width: $barWidth + '%',
		} );
		TweenMax.to( $panel3, $speed, {
			width: $focusWidth + '%',
		} );
		$( '.panel3' ).addClass( 'active' );
		$( '.panel1, .panel2' ).removeClass( 'active' );
	};

	focusFullPanel3 = function() {
		TweenMax.to( $panel3, $speed, {
			width: 94 + '%',
		} );
		TweenMax.to( $panel2, $speed, {
			width: 3 + '%',
		} );
		TweenMax.to( $panel1, $speed, {
			width: 3 + '%',
		} );
		$( '.panel3' ).addClass( 'active' );
		$( '.panel2, .panel1' ).removeClass( 'active' );
	};

	window.focusFullPanel3 = function() {
		TweenMax.to( $panel3, $speed, {
			width: 94 + '%',
		} );
		TweenMax.to( $panel2, $speed, {
			width: 3 + '%',
		} );
		TweenMax.to( $panel1, $speed, {
			width: 3 + '%',
		} );
		$( '.panel3' ).addClass( 'active' );
		$( '.panel2, .panel1' ).removeClass( 'active' );
	};

	$.fn.gclone = function( appendto, offset ) {
		if ( typeof offset === 'undefined' ) { // yet another blasted Internet Explorer fix
			offset = -5;
		}

		var position = $( this ).offset();
		var ptop = position.top;
		var pleft = position.left + offset;
		//var pleft = position.left;
		var tmppid = $( this ).attr( 'id' );
		if ( ! tmppid ) {
		//alert('no id');
			tmppid = Math.floor( ( Math.random() * 100 ) + 1 );
		} else {
		//alert('id '+tmppid);
		}
		$( this ).clone().prop( 'id', tmppid + '_clone' ).appendTo( appendto );

		$( '#' + tmppid + '_clone' ).addClass( 'cloned' );

		$( '#' + tmppid + '_clone' ).copyCSS( this );

		$( '#' + tmppid + '_clone' ).css( {
			top: ptop,
			left: pleft,
			position: 'absolute',
			'z-index': 2000,
			'filter:progid': 'DXImageTransform.Microsoft.Glow(Color=white,Strength=20)',
			'-moz-box-shadow': '0 0 20px #fff',
			'-webkit-box-shadow': '0 0 20px #fff',
			'box-shadow': '0px 0px 20px #fff',
			right: null,
		} );

		return ( '#' + tmppid + '_clone' );
	};

	$.loadSlide = function( index ) {
		if ( typeof index === 'undefined' ) { // yet another blasted Internet Explorer fix
			index = 0;
		}

		$( '.ps_guide_slide' ).hide();
		$( '#slide_' + index ).show();

		if ( $( '#slide_' + ( index - 1 ) ).length ) {
			$( '#slide_' + index + '_lastButton' ).click( function() {
				//$( ".ps_guide_slide" ).hide();
				eval( 'if(typeof slide_' + index + '_close === "function"){(slide_' + index + '_close() || Function)()}' );
				$.loadSlide( index - 1 );
			} );
		} else {
			$( '#slide_' + index + '_lastButton' ).hide();
		}

		if ( $( '#slide_' + ( index + 1 ) ).length ) {
			$( '#slide_' + index + '_nextButton' ).on( 'click', function() {
				//$( ".ps_guide_slide" ).hide();
				//$('#slide_'+index+1).show();
				eval( 'if(typeof slide_' + index + '_close === "function"){(slide_' + index + '_close() || Function)()}' );
				$.loadSlide( index + 1 );
			} );
		} else {
			$( '#slide_' + index + '_nextButton' ).hide();
		}

		//eval('if (typeof "slide_"'+index+'"_func" == "function") {console.log("running slide_"'+index+'"_func()");	slide_'+index+'_func();}');

		eval( '(slide_' + index + '_open() || Function)()' );
	};

	mode0 = function() {
	//unbindAll();
		focusFullPanel1();

		//$('.panel1, .panel2, .panel3').addClass('active');
		log( ( 100 - $drawerWidth - $barWidth - $focusOverlap ) + '%' );
	};

	focusLink = function() {
	//unbindAll();

		closeDrawer( 1 );
		closeDrawer( 2 );

		TweenMax.to( $panel2, $speed, {
			width: 46 + '%',
		} );
		TweenMax.to( $panel3, $speed, {
			width: 27 + '%',
		} );
		TweenMax.to( $panel1, $speed, {
			width: 27 + '%',
		} );
		$( '.panel2' ).addClass( 'active' );
		$( '.panel1, .panel3' ).removeClass( 'active' );

		TweenMax.to( $( '.drawer1' ), $speed, { left: '-30%' } );
		TweenMax.to( $( '.drawer2' ), $speed, { right: '-30%' } );

		//	$('#linkStatus').html("Close");
		TweenMax.to( $( '#linkStatus' ), .3, { directionalRotation: '360_ccw', className: 'open', ease: Linear.easeNone } );
		TweenMax.to( $( '#linkStatus' ), .3, { text: 'Close', ease: Linear.easeNone } );
		TweenMax.to( $( '.panel2 .content' ), .1, { className: '+=open', ease: Linear.easeNone } );
		TweenMax.to( $( '.panel2 .content .comments' ), .3, { className: '+=open', ease: Linear.easeNone } );

		$( '#linkStatus' ).unbind( 'click' );
		$( '#linkStatus' ).click( function() {
			mode2();
			//	$('#linkStatus').html("...");
			unfocusLink();
		} );
		window.focusLinkStatus = true;
		resizeContent();
	};

	unfocusLink = function() {
		if ( ! window.hasLink ) {
			var tmptext = '+';
		} else {
			var tmptext = '...';
		}

		TweenMax.to( $( '.panel2 .content' ), .1, { className: '-=open', ease: Linear.easeNone } );
		TweenMax.to( $( '.panel2 .content .comments' ), .1, { className: '-=open', ease: Linear.easeNone } );
		$( '#linkStatus' ).unbind( 'click' );
		TweenMax.to( $( '#linkStatus' ), .3, { directionalRotation: '0_cw', className: '-=open', ease: Linear.easeNone } );
		TweenMax.to( $( '#linkStatus' ), .3, { text: tmptext, ease: Linear.easeNone } );
		$( '#linkStatus' ).click( function() {
			focusLink();
		} );

		window.focusLinkStatus = false;
	//resizeContent();
	};

	fullunfocusLink = function() {
		TweenMax.to( $panel1, $speed, {
			width: ( ( 50 - $barWidth / 2 ) - $scrollbarWidth ) + '%',
		} );
		TweenMax.to( $panel2, $speed, {
			width: $barWidth + '%',
		} );
		TweenMax.to( $panel3, $speed, {
			width: ( ( 50 - $barWidth / 2 ) - $scrollbarWidth ) + '%',
		} );
		$( '.panel1, .panel2, .panel3' ).addClass( 'active' );

		$( '#bottomToolbar > div > a' ).removeClass( 'active' );
		$( '#mode2' ).addClass( 'active' );

		//unfocusLink();
	};

	mode1 = function() {
	//unbindAll();
		focusPanel1();

		TweenMax.to( $panel1, $speed, {
			width: ( 100 - $drawerWidth - $barWidth - $focusOverlap - $scrollbarWidth ) + '%',
		} );
		TweenMax.to( $panel2, $speed, {
			width: $barWidth + '%',
		} );
		TweenMax.to( $panel3, $speed, {
			width: ( ( $drawerWidth + $focusOverlap - $scrollbarWidth ) + '%' ),
		} );
		//$('.panel1, .panel2, .panel3').addClass('active');
		log( ( 100 - $drawerWidth - $barWidth - $focusOverlap ) + '%' );
	};
	//mode1();

	mode2 = function() {
	//unbindAll();

		TweenMax.to( $panel1, $speed, {
			width: ( ( 50 - $barWidth / 2 ) - $scrollbarWidth ) + '%',
		} );
		TweenMax.to( $panel2, $speed, {
			width: $barWidth + '%',
		} );
		TweenMax.to( $panel3, $speed, {
			width: ( ( 50 - $barWidth / 2 ) - $scrollbarWidth ) + '%',
		} );
		$( '.panel1, .panel2, .panel3' ).addClass( 'active' );

		$( '#bottomToolbar > div > a' ).removeClass( 'active' );
		$( '#mode2' ).addClass( 'active' );
	};
	mode2();

	mode3 = function() {
	//unbindAll();
		focusPanel3();

		log( 100 - $drawerWidth - $barWidth - $focusOverlap - $scrollbarWidth );

		TweenMax.to( $panel3, $speed, {
			width: ( ( 100 - $drawerWidth - $barWidth - $focusOverlap ) ) + '%',
		} );
		TweenMax.to( $panel2, $speed, {
			width: $barWidth + '%',
		} );
		TweenMax.to( $panel1, $speed, {
			width: ( ( $drawerWidth + $focusOverlap - $scrollbarWidth ) + '%' ),
		} );
	//$('.panel1, .panel2, .panel3').addClass('active');
	};

	mode4 = function() {
	//unbindAll();
		focusFullPanel3();
		//$('.panel1, .panel2, .panel3').addClass('active');
		log( ( 100 - $drawerWidth - $barWidth - $focusOverlap ) + '%' );
	};

	$( '.focus' ).click( function() {
		mode2();
		resizeContent();
		unfocusLink();
	} );

	$( '#mode0' ).click( function() {
		mode0();
		resizeContent();
		$( '#bottomToolbar > div > a' ).removeClass( 'active' );
		$( this ).addClass( 'active' );
		unfocusLink();
	} );

	$( '#mode1' ).click( function() {
		mode1();
		resizeContent();
		$( '#bottomToolbar > div > a' ).removeClass( 'active' );
		$( this ).addClass( 'active' );
		unfocusLink();
	} );

	$( '#mode2' ).click( function() {
		mode2();
		resizeContent();
		$( '#bottomToolbar > div > a' ).removeClass( 'active' );
		$( this ).addClass( 'active' );
		unfocusLink();
	} );

	$( '#mode3' ).click( function() {
		mode3();
		resizeContent();
		$( '#bottomToolbar > div > a' ).removeClass( 'active' );
		$( this ).addClass( 'active' );
		unfocusLink();
	} );

	$( '#mode4' ).click( function() {
		mode4();
		resizeContent();
		$( '#bottomToolbar > div > a' ).removeClass( 'active' );
		$( this ).addClass( 'active' );
		unfocusLink();
	} );

	$( '#helpPage' ).click( function( event ) {
		log( 'going' );

		//window.loadContentByURL("div.panel.panel1","/2up-help/");

		//window.loadPageByURL("1","/2up-help/");

		//if($("#2up_guide").length == 0) {
		$( 'body' ).append( '<div id="ps_2up_guide"></div>' );
		window.loadContentByURL( 'div#ps_2up_guide', '/2up-help/' );
		//}else{
		//	$("#2up_guide").show();
		//}

		//$('#2up_guide').css('z-index',"1000");
	} );

	var windowHeightHalf = $( window ).height();
	windowHeightHalf = windowHeightHalf / 2 - 60;

	var javaCSS = '<style>\
#linkStatus{\
	margin:' + windowHeightHalf + 'px auto 0px auto;\
}\
</style>';

	$( 'head' ).append( javaCSS );
} );

